<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <Avatar :src="userAvator" size="26" style="margin-top: 2px;"/>
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="message">
          消息中心<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
        </DropdownItem>
        <DropdownItem name="setting">个人资料</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <self-info-modal v-model="selfInfoModal" ></self-info-modal>
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
import SelfInfoModal from '@/view/acl/components/self-info-modal'
export default {
  name: 'User',
  components: { SelfInfoModal },
  props: {
    userAvator: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      selfInfoModal: false
    }
  },
  methods: {
    ...mapActions([
      'AccountServ_Logout'
    ]),
    logout () {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: 'login'
        })
      })
    },
    message () {
      this.$router.push({
        name: 'message_page'
      })
    },
    handleClick (name) {
      switch (name) {
        case 'logout':
          this.$Modal.confirm({
            title: '确认退出系统',
            content: '<p>确认退出系统</p>',
            onOk: () => {
              this.AccountServ_Logout({
                extfunc: (commit, params, urlparams) => {
                  commit('setToken', '')
                  commit('setAccess', [])
                  this.$router.push({
                    name: 'login'
                  })
                }
              }).then(() => {

              })
            },
            onCancel: () => {

            }
          })
          break
        case 'setting':
          this.selfInfoModal = true
          // this.$router.push({
          //   name: 'setting'
          // })
          break
        case 'message': this.message()
          break
      }
    }
  }
}
</script>
